import { render, staticRenderFns } from "./ModalCadastroAtividade.vue?vue&type=template&id=cbf73784"
import script from "./ModalCadastroAtividade.vue?vue&type=script&lang=js"
export * from "./ModalCadastroAtividade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports